/**
 * @desc 获取授权信息
 */
const URL = "/rantion-basics";
import http, { updateResponse } from "@/http";
export type Response = defs.basics.ResponseDto<defs.basics.AuthorizationRecordResponseRpcDto>;
export function request(
  body: defs.basics.AuthorizationRecordRequestParamsRpcDto,
  options?: any,
): Promise<Response> {
  return updateResponse(
    http(URL + `/rpc/basics/getAuthorizationRecordFacadeInfo`, {
      method: "POST",

      data: body,
      ...options,
    }),
  );
}
